import { helpers, required } from '@vuelidate/validators'

import SelectMultipleFieldPlugin from '@/features/settingsManagement/fieldManagement/edit/plugin/selectMultipleFieldPlugin/SelectMultipleFieldPlugin.vue'
import SelectMultipleFieldPluginValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/selectMultipleFieldPlugin/SelectMultipleFieldPluginValueRenderer.vue'

const defaultData = {
  placeholder: 'Choose...',
  options: [], // [{label: 'Option 1', value: 1}, {label: 'Option 2', value: 2}]
}

export const selectMultipleFieldPlugin = {
  type: 'select-multiple',
  component: SelectMultipleFieldPlugin,
  valueRenderer: SelectMultipleFieldPluginValueRenderer,
  defaultExtraData: defaultData,
  getValidations({ props }) {
    const field = props.field
    const rules = {}
    const key = field.key

    const isRequired =
      typeof props.externalRequired === 'boolean' ? props.externalRequired : field.isCompulsory
    if (isRequired) {
      const message = `${key} is required`
      rules.required = helpers.withMessage(message, required)
    }

    return rules
  },
}
